import { useEffect, useState } from 'react';

const MOBILE_MAX_WIDTH = 640;
const TABLET_MAX_WIDTH = 1024;

export type Breakpoint = 'mobile' | 'tablet' | 'desktop';

export default function useBreakpoint() {
  const [width, setWidth] = useState(() => {
    if (typeof window === 'undefined') {
      return TABLET_MAX_WIDTH + 1;
    }
    return window.innerWidth;
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handleResize = () => setWidth(window.innerWidth);
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = width <= MOBILE_MAX_WIDTH;
  const isTablet = width > MOBILE_MAX_WIDTH && width <= TABLET_MAX_WIDTH;
  const isDesktop = width > TABLET_MAX_WIDTH;

  const breakpoint: Breakpoint = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';

  return { width, breakpoint, isMobile, isTablet, isDesktop };
}
